import { TramiteTurno } from '../models/citas.models';

/** Indica si el turno tiene trámites agendados (exige vincular socio). */
export function turnoTieneTramitesAgendados(tramites: TramiteTurno[] | undefined | null): boolean {
  return (tramites ?? []).some((t) => !!(t?.nombre || t?.id));
}

/** True cuando el representante puede concluir (socio vinculado o solicitud de informes registrada). */
export function puedeConcluirAtencionTurno(turno: {
  maestro_id?: number | null;
  pidio_informes?: boolean;
}): boolean {
  return !!(turno.maestro_id || turno.pidio_informes);
}

/** True cuando puede registrarse atención solo informativa (sin socio vinculado). */
export function puedeRegistrarSolicitudInformes(turno: {
  maestro_id?: number | null;
  pidio_informes?: boolean;
}): boolean {
  return !turno.maestro_id && !turno.pidio_informes;
}

/** Trámite agendado que exige socio vinculado (no aplica cierre solo informes). */
export function turnoExigeSocioPorTramite(tramites: TramiteTurno[] | undefined | null): boolean {
  return turnoTieneTramitesAgendados(tramites);
}
